export default __webpack_public_path__ + "static/media/B161.bb975189.png";